import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasNavPermission } from '../components/ProtectedRoute';
import './AdminHubPage.css';

// Producción, grouped into subsections; a subsection only shows when the user can open one of
// its pages.
const GROUPS = [
  {
    title: 'Enfunde',
    sections: [
      { to: '/enfunde', icon: '🎋', label: 'Control de Enfunde', desc: 'Registrar el enfunde semanal por lote y trabajador', key: 'production' },
      { to: '/enfunde/list', icon: '📋', label: 'Historial de Enfunde', desc: 'Ver y editar las hojas semanales guardadas', key: 'production' },
    ],
  },
  {
    title: 'Presupuesto',
    sections: [
      {
        to: '/production-budget', icon: '✏️', label: 'Presupuesto de Cajas',
        desc: 'Ingresar las cajas presupuestadas por finca y semana', key: 'production_budget',
      },
    ],
  },
  {
    title: 'Detalles de Cosecha',
    sections: [
      { to: '/cosecha', icon: '🍌', label: 'Detalles de Cosecha', desc: 'Registrar los datos de cosecha de una venta', key: 'harvest' },
      { to: '/cosecha/historial', icon: '📋', label: 'Historial de Cosecha', desc: 'Ver y editar los detalles de cosecha registrados', key: 'harvest' },
    ],
  },
  {
    title: 'Analítica',
    sections: [
      {
        to: '/recobro', icon: '📈', label: 'Recobro de Cintas',
        desc: 'Racimos enfundados vs. cosechados por semana y cinta', key: 'recobro',
      },
      {
        to: '/production-summary', icon: '📊', label: 'Resumen de Producción',
        desc: 'Cajas producidas vs. presupuestadas, cumplimiento y enfunde por semana y finca', key: 'production_summary',
      },
    ],
  },
  {
    title: 'Fumigación',
    sections: [
      {
        to: '/fumigacion', icon: '✈️', label: 'Fumigación Aérea',
        desc: 'Registrar los ciclos de fumigación aérea: productos, dosis, compañía y piloto', key: 'fumigation',
      },
      {
        to: '/fumigacion/historial', icon: '📋', label: 'Historial de Fumigación',
        desc: 'Ver, editar y exportar las fumigaciones registradas', key: 'fumigation',
      },
    ],
  },
];

export default function ProductionHubPage() {
  const { user } = useAuth();
  // `key` may list several grants: the card shows with any of them.
  const canOpen = (s) => [].concat(s.key).some((k) => hasNavPermission(user, k));
  const visibleGroups = GROUPS
    .map((g) => ({ ...g, sections: g.sections.filter(canOpen) }))
    .filter((g) => g.sections.length);
  return (
    <div className="admin-hub-root">
      <h1 className="admin-hub-title hub-title-divided">🌾 Producción</h1>
      {visibleGroups.map((g) => (
        <section key={g.title} className="hub-group">
          <h2 className="hub-group-title">{g.title}</h2>
          <div className="admin-hub-grid">
            {g.sections.map((s) => (
              <Link key={s.to} to={s.to} className="admin-hub-card">
                <span className="admin-hub-icon">{s.icon}</span>
                <div>
                  <div className="admin-hub-label">{s.label}</div>
                  <div className="admin-hub-desc">{s.desc}</div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
